<template>
  <div class="sim-cards-wrapper">
    <div class="card first-card card-left" :class="lockClass">
      <LockSimCardWrapper
        @error="setError"
        @error-clear="clearError"
        :lock-status.sync="lockStatus">
        <template v-for="slot in possibleChildSlotsFor('LockSim')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </LockSimCardWrapper>
    </div>
    <div class="card second-card card-right">
      <SubstituteSimCardWrapper :order-target-url="substituteSimTargetUrl" :sim-order-status="simOrderStatus">
        <template v-for="slot in possibleChildSlotsFor('SubstituteSim')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </SubstituteSimCardWrapper>
    </div>
    <div class="card" v-if="isEsimSwapAvailable">
      <EsimSwapCardWrapper
          :order-target-url="substituteSimTargetUrl"
          :sim-order-status="simOrderStatus"
          :available-device-types="availableDeviceTypes">
        <template v-for="slot in possibleChildSlotsFor('EsimSwap')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </EsimSwapCardWrapper>
    </div>
    <div v-if="hasError" class="card error-box">{{ errorMessage }}</div>
  </div>
</template>

<script>
import SubstituteSimCardWrapper from '@/components/process/wrapper/SelfService/SimCard/SubstituteSimCardWrapper.vue'
import LockSimCardWrapper from '@/components/process/wrapper/SelfService/SimCard/LockSimCardWrapper.vue'
import EsimSwapCardWrapper from '@/components/process/wrapper/SelfService/SimCard/EsimSwapCardWrapper.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import substituteSimCardProducts from '@/mixins/substituteSimCardProducts'

export default {
  name: 'SimCardWrapper',
  data () {
    return {
      lockStatus: false,
      errorMessage: null,
      simOrderStatus: {
        orderDate: null,
        activatable: false,
        orderable: false,
        statusInfo: ''
      },
      currentCustomer: {
        contract: {
          simCard: {
            type: '',
            status: ''
          }
        }
      }
    }
  },
  methods: {
    setError (message) {
      this.errorMessage = message
    },
    clearError () {
      this.errorMessage = null
    }
  },
  computed: {
    hasError () {
      return this.errorMessage !== null
    },
    lockClass: function () {
      return this.lockStatus ? 'locked' : ''
    },
    isEsimSwapAvailable: function () {
      return this.currentCustomer?.contract?.simCard?.type === 'SIM_CARD'
    },
    isFreeEsimSwapAvailable: function () {
      return this.isEsimSwapAvailable && this.isEsimFree
    }
  },
  components: {
    SubstituteSimCardWrapper,
    LockSimCardWrapper,
    EsimSwapCardWrapper
  },
  props: {
    substituteSimTargetUrl: {
      type: String,
      default: ''
    },
    availableDeviceTypes: {
      type: String,
      default: ''
    }
  },
  mixins: [
    substituteSimCardProducts()
  ],
  apollo: {
    simOrderStatus: function () {
      return wrapQuery(gql`
        query substituteSim {
          simOrderStatus {
            orderDate,
            activatable,
            orderable,
            statusInfo,
            type
          }
        }`, this, 'simOrderStatus')
    },
    currentCustomer: function () {
      return wrapQuery(gql`
        query currentCustomer {
          currentCustomer {
            contract {
              simCard {
                type
                status
              }
            }
          }
        }`, this, 'currentCustomer')
    }
  }
}
</script>
